var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoonEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.14,
    height: 14.565,
    viewBox: "0 0 54.14 14.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled-3-01",
    transform: "translate(629.82 8.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164586",
    "data-name": "Path 164586",
    d: "M170.194,237.626a2.4,2.4,0,0,0-.208-1.26.833.833,0,0,0-.109-.181.73.73,0,0,0-.144-.122,1.817,1.817,0,0,0-1-.313",
    transform: "translate(-793.755 -243.756)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164587",
    "data-name": "Path 164587",
    d: "M167.113,233.533a4.659,4.659,0,0,0,.009-.948,1.577,1.577,0,0,0-.36-.863.955.955,0,0,0-.849-.325,4.141,4.141,0,0,1-.563.145",
    transform: "translate(-790.673 -239.777)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164588",
    "data-name": "Path 164588",
    d: "M136.678,235.337c-.252-.274-.514-.539-.785-.794a1.088,1.088,0,0,0-.8-.378q-.47-.056-.942-.082a1.208,1.208,0,0,0-.475.037,1.283,1.283,0,0,0-.531.456l-.754.944a1.233,1.233,0,0,0-.242.4,1.069,1.069,0,0,0-.033.34,4.38,4.38,0,0,0,.086.782,1.308,1.308,0,0,0,.131.394,1.486,1.486,0,0,0,.244.3l.56.576",
    transform: "translate(-760.376 -242.229)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164589",
    "data-name": "Path 164589",
    d: "M131.823,238.851q-.009-1-.019-2a1.9,1.9,0,0,1,.05-.56,1.925,1.925,0,0,1,.92-.958,2.62,2.62,0,0,1,1.985-.516.636.636,0,0,1,.254.043.832.832,0,0,1,.214.176c.289.279.71.46.842.839",
    transform: "translate(-760.087 -242.898)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164590",
    "data-name": "Path 164590",
    d: "M129.757,230.345a.964.964,0,0,0-.6-.559,2.449,2.449,0,0,0-.833-.115,7.432,7.432,0,0,0-2.446.328,1.705,1.705,0,0,0-.466.22,2.029,2.029,0,0,0-.364.373,3.05,3.05,0,0,0-.69,1.152,2.87,2.87,0,0,0-.063.614,2.945,2.945,0,0,0,.157,1.226,2.978,2.978,0,0,0,.745.946q.487.463,1,.9",
    transform: "translate(-753.242 -238.213)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164591",
    "data-name": "Path 164591",
    d: "M126.128,239.96l-.394.565a2.293,2.293,0,0,0-.546,1.523,1.784,1.784,0,0,0,.122.988,2.86,2.86,0,0,0,.773.708c.5.412.835,1.033,1.425,1.3",
    transform: "translate(-754.042 -247.594)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164592",
    "data-name": "Path 164592",
    d: "M139.18,232.181a3.031,3.031,0,0,0,1.071-.222,5.59,5.59,0,0,1,1.326-.229,1.226,1.226,0,0,1,.413.032,1.107,1.107,0,0,1,.361.209,2.227,2.227,0,0,1,.6.705,3.583,3.583,0,0,1,.3,1.26",
    transform: "translate(-766.813 -240.088)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164593",
    "data-name": "Path 164593",
    d: "M129.708,254.49a2.233,2.233,0,0,0,.462,1.95l.482.681a2.146,2.146,0,0,0,.311.375,5.489,5.489,0,0,0,.551.363c.686.476.947,1.378,1.571,1.933",
    transform: "translate(-758.149 -260.842)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164594",
    "data-name": "Path 164594",
    d: "M122.283,258.73A2.059,2.059,0,0,0,122.6,260a14.488,14.488,0,0,0,.845,1.433,2.808,2.808,0,0,0,.527.623,5.786,5.786,0,0,0,.625.4,7.007,7.007,0,0,1,.743.56c.461.38.922.76,1.368,1.158",
    transform: "translate(-751.39 -264.707)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164595",
    "data-name": "Path 164595",
    d: "M152.36,299.239a1.576,1.576,0,0,1,.98.333,8.664,8.664,0,0,1,1.2.93,4.133,4.133,0,0,1,1.025,1.342,3.718,3.718,0,0,1,.032,2.559c-.015.048-.1.09-.1.04",
    transform: "translate(-778.829 -301.637)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164596",
    "data-name": "Path 164596",
    d: "M159.12,314.51a3.524,3.524,0,0,1,2.581,3.334,1.89,1.89,0,0,1-.685,1.625l-.074-.076",
    transform: "translate(-784.993 -315.564)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164597",
    "data-name": "Path 164597",
    d: "M165.785,312.33a7.551,7.551,0,0,1,1.177,1.834,4.918,4.918,0,0,1,.492,2.144,4.677,4.677,0,0,1-.4,1.7.591.591,0,0,1-.168.252.61.61,0,0,1-.274.092l-.911.151c-.191.032-.438.035-.519-.14",
    transform: "translate(-790.518 -313.577)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164598",
    "data-name": "Path 164598",
    d: "M143.562,321.46c.124.125.246.252.362.384a3.991,3.991,0,0,1,.778,3.992,1.062,1.062,0,0,1-.227.378,1.234,1.234,0,0,1-.336.209,5.846,5.846,0,0,1-1.454.549,1.974,1.974,0,0,1-1.5-.26",
    transform: "translate(-768.645 -321.901)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164599",
    "data-name": "Path 164599",
    d: "M119.779,345.9a3.805,3.805,0,0,0-.014,1.488,2.216,2.216,0,0,0,.74,1.268,3.625,3.625,0,0,0,1.1.533l1.093.386",
    transform: "translate(-749.05 -344.184)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164600",
    "data-name": "Path 164600",
    d: "M121.264,353.27a2.045,2.045,0,0,0,.983,2.114,3.024,3.024,0,0,0,.928.624,2.915,2.915,0,0,0,.982.118q.549,0,1.1-.017",
    transform: "translate(-750.465 -350.904)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164601",
    "data-name": "Path 164601",
    d: "M117.223,362.19a1.261,1.261,0,0,0,.184.649,1.732,1.732,0,0,0,.309.484,1.482,1.482,0,0,0,.483.294,9.145,9.145,0,0,0,1.825.5,4.329,4.329,0,0,0,.915.109,2.306,2.306,0,0,0,1.3-.434",
    transform: "translate(-746.791 -359.036)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164602",
    "data-name": "Path 164602",
    d: "M181.01,340.31a5,5,0,0,1-.131,1.749,3.049,3.049,0,0,1-.9,1.49c-.052.045-.124.091-.184.057l-.04-.2",
    transform: "translate(-803.811 -339.087)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164603",
    "data-name": "Path 164603",
    d: "M176.99,320.02a3.009,3.009,0,0,1,.754,4.331l-.051-.065",
    transform: "translate(-801.286 -320.588)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164604",
    "data-name": "Path 164604",
    d: "M170.878,322.24c.082.075.151.166.225.249a1.11,1.11,0,0,1,.23.3,5.973,5.973,0,0,1,.341,1.183c.037.2.1.393.131.592.029.168.041.336.057.5.019.206.009.418.009.625,0,.114.005.229,0,.342a.377.377,0,0,1-.057.167,2.119,2.119,0,0,1-.186.264c-.056.072-.1.152-.154.226-.064.093-.138.177-.206.268-.049.065-.089.134-.138.2-.026.035-.07.064-.083.108a1.115,1.115,0,0,1-.189,0",
    transform: "translate(-795.697 -322.612)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164605",
    "data-name": "Path 164605",
    d: "M124.445,347.95v.8a2.8,2.8,0,0,1-.034.637,2.766,2.766,0,0,1-.135.414,1.9,1.9,0,0,1-.335.521,1.111,1.111,0,0,1-.239.2,3.075,3.075,0,0,1-.477.279c-.2.087-.389.181-.592.251a1.607,1.607,0,0,1-.531.048c-.263,0-.525.016-.787.033-.243.016-.49,0-.733,0h-.5a1.02,1.02,0,0,1-.441-.055,1.867,1.867,0,0,1-.289-.166,2.347,2.347,0,0,0-.281-.134c-.1-.053-.2-.122-.3-.169a.347.347,0,0,1-.164-.185.394.394,0,0,0-.122-.153c-.046-.034-.1-.068-.108-.132",
    transform: "translate(-747.839 -346.053)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164606",
    "data-name": "Path 164606",
    d: "M123.022,272.52c0,.056,0,.111,0,.167a1.13,1.13,0,0,0,.1.459,2.155,2.155,0,0,0,.332.559c.189.221.417.394.622.6.077.076.15.156.231.229.124.111.263.2.383.319s.24.228.372.335a1.99,1.99,0,0,1,.235.221,1.531,1.531,0,0,0,.261.209,4.123,4.123,0,0,1,.434.358c.144.14.3.261.454.393.1.084.184.174.288.248a2.118,2.118,0,0,0,.23.144",
    transform: "translate(-752.079 -277.28)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164607",
    "data-name": "Path 164607",
    d: "M140.25,289.73a1.536,1.536,0,0,0,.2.206c.138.132.272.269.409.4s.292.263.443.39.3.277.447.42a5.424,5.424,0,0,0,.6.541c.084.06.148.133.228.2s.184.137.269.214a4.668,4.668,0,0,1,.967.961,2.548,2.548,0,0,1,.14.266,1.822,1.822,0,0,1,.09.3,1.162,1.162,0,0,0,.086.246.256.256,0,0,0,.041.074",
    transform: "translate(-767.788 -292.971)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164608",
    "data-name": "Path 164608",
    d: "M158.309,302.48c0,.038.041.07.064.1.146.17.3.317.432.5a11.05,11.05,0,0,1,.8,1.38c.209.4.446.782.67,1.174.112.2.22.389.316.593a2.984,2.984,0,0,1,.252.763,3.115,3.115,0,0,1,.036.529v-.045",
    transform: "translate(-784.254 -304.596)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164609",
    "data-name": "Path 164609",
    d: "M163.62,304.377c.026,0,.049,0,.076,0a.541.541,0,0,1,.263.132,7.772,7.772,0,0,1,.88.742,7.258,7.258,0,0,1,.694.759,3,3,0,0,1,.3.449,2.073,2.073,0,0,1,.144.408,2.568,2.568,0,0,1,.068.278,1.959,1.959,0,0,1,.012.313,1.132,1.132,0,0,0,.033.316.145.145,0,0,0,.043.085v-.011",
    transform: "translate(-789.096 -306.323)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164610",
    "data-name": "Path 164610",
    d: "M143.43,284.21c.022,0,.037.012.043.041.039.054.08.106.124.156.133.159.288.3.428.45a6.007,6.007,0,0,1,.473.585c.1.14.193.285.3.42a2.574,2.574,0,0,0,.206.243c.086.085.181.16.267.243.122.119.21.273.333.389l0-.014",
    transform: "translate(-770.687 -287.938)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164611",
    "data-name": "Path 164611",
    d: "M124.543,237.492a1.177,1.177,0,0,0-.14-.4,2.605,2.605,0,0,1-.16-.5,1.418,1.418,0,0,1-.057-.276c0-.1-.015-.2-.019-.308a1.913,1.913,0,0,0-.037-.233,2.009,2.009,0,0,1-.038-.364,1.262,1.262,0,0,1,.051-.488c.036-.091.077-.179.109-.272a3.263,3.263,0,0,1,.483-.853,1.778,1.778,0,0,1,.229-.2,2.884,2.884,0,0,1,.255-.233.228.228,0,0,1,.088-.034,1.473,1.473,0,0,0,.219-.062c.191-.071.379-.131.574-.189l.189-.056a.5.5,0,0,1,.119-.037.206.206,0,0,1-.065,0",
    transform: "translate(-753.056 -241.239)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164612",
    "data-name": "Path 164612",
    d: "M133.346,233.759c0-.229,0-.457,0-.686a.757.757,0,0,0-.005-.109.3.3,0,0,0-.063-.151,2.058,2.058,0,0,0-.184-.188,1.962,1.962,0,0,0-.235-.219,3.494,3.494,0,0,0-.337-.187.371.371,0,0,0-.153-.055.468.468,0,0,1-.11-.021,1.081,1.081,0,0,1-.137-.072c-.063-.032-.13-.062-.191-.1s-.123-.091-.191-.127-.132-.058-.2-.1a.8.8,0,0,0-.377-.094,4.072,4.072,0,0,0-.605.011,1.259,1.259,0,0,0-.506.178c-.132.08-.283.133-.419.207a2.279,2.279,0,0,0-.4.215,1.152,1.152,0,0,0-.17.214,3.277,3.277,0,0,0-.249.318c-.067.115-.123.225-.178.338-.038.077-.087.144-.13.218a1.83,1.83,0,0,0-.078.192,1.332,1.332,0,0,0-.067.312c-.024.127-.036.257-.059.384a2.027,2.027,0,0,0,.029.506,1.144,1.144,0,0,0,.021.19,1.479,1.479,0,0,0,.094.241,6.526,6.526,0,0,0,.377.677c.051.087.116.167.174.25.031.043.086.161.143.174l0-.03",
    transform: "translate(-756.891 -240.019)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164613",
    "data-name": "Path 164613",
    d: "M235.616,256.788v-.029c0,.211.012.416-.006.627a6.778,6.778,0,0,1-.191.984q-.1.432-.186.868c-.041.173-.081.347-.123.52a2.1,2.1,0,0,0-.012.408c0,.347,0,.694,0,1.041s.012.661.042.991a3.056,3.056,0,0,0,.168.859,4.075,4.075,0,0,0,.928,1.433c.054-.012.174-.057.138-.124a7.316,7.316,0,0,1-.352-.657,10.207,10.207,0,0,1-.366-1.036c-.057-.191-.1-.387-.15-.579a5.02,5.02,0,0,1-.143-.514c-.051-.29-.086-.589-.109-.883a13.445,13.445,0,0,1,.1-2.284c.019-.22.063-.433.064-.655,0-.175,0-.35,0-.524s0-.376-.014-.565a.3.3,0,0,1,.027-.159,1.854,1.854,0,0,1,.229-.326c.131-.169.271-.333.411-.5.034-.038.14-.12.1-.18",
    transform: "translate(-854.26 -261.772)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164614",
    "data-name": "Path 164614",
    d: "M233.066,286.636c-.1.012-.218-.068-.3-.1a4.57,4.57,0,0,1-.589-.217c-.2-.114-.42-.174-.623-.283a3.879,3.879,0,0,1-1.243-1.325,11.674,11.674,0,0,1-.9-1.394,4.384,4.384,0,0,1-.391-1.327c-.032-.221-.059-.442-.087-.663a8.048,8.048,0,0,1-.033-1.062v-1.276a11.912,11.912,0,0,0,.308,1.333c.039.239.092.477.14.714a5.334,5.334,0,0,0,.192.9,5.682,5.682,0,0,0,.567,1.027,14.09,14.09,0,0,1,.755,1.526,1.047,1.047,0,0,0,.209.327c.058.055.118.111.178.162s.111.071.163.112a2.064,2.064,0,0,1,.208.2c.147.158.282.32.421.484a2.8,2.8,0,0,0,.341.338,2.13,2.13,0,0,1,.253.282.732.732,0,0,0,.5.241,4.532,4.532,0,0,1,.647.141,4.5,4.5,0,0,0,.788.1c.108,0,.208.035.317.036h.274a3.469,3.469,0,0,0,.765-.032,10.372,10.372,0,0,0,1.106-.326,6.031,6.031,0,0,0,.652-.232,4.452,4.452,0,0,0,.5-.307c.218-.147.431-.305.643-.462a2.267,2.267,0,0,0,.354-.285c.086-.093.161-.189.237-.289a4.588,4.588,0,0,0,.745-1.127,6.152,6.152,0,0,1,.423-.932,3.861,3.861,0,0,0,.342-.62,3.753,3.753,0,0,0,.2-.686,6.842,6.842,0,0,0,.078-.97,11.738,11.738,0,0,0-.026-1.557c-.04-.337-.081-.672-.114-1.01-.011-.116-.023-.23-.032-.346-.017-.2-.036-.243-.244-.293",
    transform: "translate(-848.61 -281.766)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164615",
    "data-name": "Path 164615",
    d: "M355.79,258.28a.7.7,0,0,0,.11.208c.1.18.169.371.268.551s.18.394.276.587c.081.163.185.314.26.48a3.107,3.107,0,0,1,.3.864c.076.553.1,1.11.126,1.667.011.2,0,.407,0,.61a1.852,1.852,0,0,1-.016.408c-.072.326-.145.649-.226.973a4.3,4.3,0,0,1-.145.549c-.066.168-.111.337-.164.509a5.022,5.022,0,0,1-.174.552c-.045.1-.061.219-.109.318a.183.183,0,0,1-.062-.146",
    transform: "translate(-964.305 -264.297)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164616",
    "data-name": "Path 164616",
    d: "M347.581,264.92c0,.064,0,.13,0,.194a1.23,1.23,0,0,0,.1.51,9.584,9.584,0,0,1,.35.994c.093.342.176.681.258,1.024a8.851,8.851,0,0,1,.224,2.063c0,.255,0,.51,0,.765a2.766,2.766,0,0,1-.158.843,3.954,3.954,0,0,1-.911,1.461c-.138.148-.274.3-.41.448a1.912,1.912,0,0,0-.238.283,1.527,1.527,0,0,1-.295.332c-.145.135-.3.059-.473.006",
    transform: "translate(-955.407 -270.351)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164617",
    "data-name": "Path 164617",
    d: "M285.183,335.19a.73.73,0,0,1-.1.352,4.443,4.443,0,0,1-.306.582,3.662,3.662,0,0,1-.894,1.093c-.246.186-.432.417-.66.621-.141.127-.259.272-.409.389a8.1,8.1,0,0,1-.852.573,4.988,4.988,0,0,1-1.357.63,3.568,3.568,0,0,1-.818.031h-.823c-.16,0-.32,0-.48,0s-.305-.038-.462-.035a2.534,2.534,0,0,1-.528-.06,4.581,4.581,0,0,1-.541-.216",
    transform: "translate(-892.423 -334.419)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164618",
    "data-name": "Path 164618",
    d: "M232.363,251.361v-.9a3.4,3.4,0,0,1,0-.342,5.247,5.247,0,0,1,.484-1.455c.081-.19.151-.383.233-.572.03-.07.054-.142.083-.212a1.121,1.121,0,0,1,.2-.276c.057-.069.091-.148.145-.218.069-.09.153-.171.229-.254a2.629,2.629,0,0,1,.391-.329,1.244,1.244,0,0,1,.3-.2.246.246,0,0,1-.065.117c-.145.189-.327.349-.483.529a1.844,1.844,0,0,0-.178.287c-.093.159-.142.341-.233.5a2.637,2.637,0,0,0-.109.276c-.04.092-.094.186-.139.277-.078.153-.163.3-.241.455-.068.135-.132.275-.207.406a2.154,2.154,0,0,0-.244.417,1.657,1.657,0,0,0-.031.486",
    transform: "translate(-851.766 -253.657)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164619",
    "data-name": "Path 164619",
    d: "M259.76,236.08a.359.359,0,0,0,.175-.071c.174-.1.346-.2.516-.308a7.582,7.582,0,0,1,.7-.43,2.6,2.6,0,0,1,.395-.119c.207-.061.411-.122.622-.174s.432-.114.651-.154a4.523,4.523,0,0,1,.695-.021,2.52,2.52,0,0,1,.684.141c.084.023.162.059.245.082a1.783,1.783,0,0,1,.206.052c.127.052.227.144.358.192a4.31,4.31,0,0,1,.508.222c.2.1.389.215.589.312.153.074.275.191.425.273a1.912,1.912,0,0,1,.492.313c.09.094.167.2.249.3.139.169.306.319.439.492.043.056.123.127.108.2",
    transform: "translate(-876.751 -242.889)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164620",
    "data-name": "Path 164620",
    d: "M259.9,229.6a.9.9,0,0,1,.555.206,1.1,1.1,0,0,1,.357.38c.068.123.159.221.223.346a3.3,3.3,0,0,0,.243.335c.077.113.136.239.222.352a.9.9,0,0,1,.2.409c.041.211.1.417.13.629.008.047.03.088.036.133s-.011.067.006.1c.029-.009-.387-.1-.387-.138a.688.688,0,0,0-.138-.343.974.974,0,0,0-.138-.227c-.056-.062-.113-.123-.165-.188-.19-.242-.295-.552-.507-.775-.231-.243-.437-.5-.675-.741-.208-.208-.32-.486-.52-.7a2.126,2.126,0,0,0-.786-.451,5.741,5.741,0,0,0-.722-.226,4.416,4.416,0,0,0-1-.174,7.075,7.075,0,0,0-1.283.043,3.62,3.62,0,0,0-.828.312c-.269.121-.515.227-.779.329a1.068,1.068,0,0,0-.342.171c-.048.041-.1.07-.153.109a1.333,1.333,0,0,0-.163.176,2.36,2.36,0,0,0-.165.172,9.672,9.672,0,0,0-.663.853,1.094,1.094,0,0,0-.173.414c-.007.08,0,.166,0,.247",
    transform: "translate(-869.932 -237.166)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164621",
    "data-name": "Path 164621",
    d: "M284.35,232.611c.146,0,.294.01.439,0,.1-.005.186-.034.283-.038a2.78,2.78,0,0,0,.31-.006,6.746,6.746,0,0,1,.681-.025c.191-.007.373-.037.565-.036a1.855,1.855,0,0,1,.459.033c.077.018.148.048.223.071.11.035.227.037.338.067a4.618,4.618,0,0,1,.605.173c.131.055.237.146.364.206.09.042.188.064.277.108a2.024,2.024,0,0,1,.337.228c.221.168.443.334.659.51.189.153.4.281.585.44.108.1.191.2.29.308s.164.23.267.334a1.626,1.626,0,0,1,.249.48,2.331,2.331,0,0,0,.294.62c.07.077.193.148.236.245a1.827,1.827,0,0,1-.4-.069",
    transform: "translate(-899.17 -240.799)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164622",
    "data-name": "Path 164622",
    d: "M371.956,280.53c0,.381,0,.762,0,1.143,0,.288.086.563.116.848s.039.59.056.884c.03.525,0,1.058.006,1.585a2.015,2.015,0,0,1-.193.778.74.74,0,0,1-.164.3.264.264,0,0,1-.025-.168",
    transform: "translate(-978.852 -284.583)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164623",
    "data-name": "Path 164623",
    d: "M319.862,286c0,.595-.026,1.2,0,1.791.03.633.065,1.267.066,1.9a5.969,5.969,0,0,1-.1,1.209,4.854,4.854,0,0,1-.173.682c-.056.153-.13.3-.19.448s-.139.321-.215.481a2.31,2.31,0,0,1-.236.469,3.406,3.406,0,0,1-.639.6,9.15,9.15,0,0,1-.862.614,3.858,3.858,0,0,1-.713.348,2.808,2.808,0,0,1-.3.108l-.051.006-.857-.177",
    transform: "translate(-927.653 -289.571)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164624",
    "data-name": "Path 164624",
    d: "M249.318,236.3v.018a2.044,2.044,0,0,0-.155-.673c-.059-.2-.139-.388-.2-.588a1.384,1.384,0,0,0-.163-.367c-.121-.184-.286-.335-.407-.519a6.29,6.29,0,0,0-1.153-1c-.079-.072-.147-.157-.229-.225-.1-.083-.215-.143-.312-.23a3.541,3.541,0,0,0-.819-.494,5.923,5.923,0,0,0-1.329-.413,3.14,3.14,0,0,0-.785-.094c-.2,0-.408,0-.612,0a4.44,4.44,0,0,0-1.5.171c-.276.1-.524.219-.791.337a2.388,2.388,0,0,0-.239.139c-.078.045-.164.072-.243.117-.108.062-.2.148-.312.2a.716.716,0,0,0-.2.1c0-.008-.172-.326-.172-.334.012.081-.053.139-.1.2a4.432,4.432,0,0,1-.286.37c-.131.135-.281.247-.406.388-.051.057-.125.109-.169.169-.029.042-.046.1-.074.147a2.236,2.236,0,0,0-.139.229c-.088.189-.169.381-.257.57s-.145.36-.236.532c-.056.106-.116.2-.163.313a4.929,4.929,0,0,0-.2.621,2.059,2.059,0,0,0-.113.616c0,.131,0,.26,0,.391s.034.311-.07.4",
    transform: "translate(-856.455 -240.08)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164625",
    "data-name": "Path 164625",
    d: "M228.537,268.43a2.042,2.042,0,0,1-.029.519c-.044.17-.126.319-.173.484-.03.106-.034.214-.06.32-.034.138-.068.275-.1.413-.024.1-.063.194-.086.293-.031.135-.038.274-.058.41a2.4,2.4,0,0,0,.014,1.1c.11.306.225.623.3.938a2.629,2.629,0,0,0,.158.482.692.692,0,0,1,.1.258.629.629,0,0,1,0-.157",
    transform: "translate(-847.768 -273.551)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164626",
    "data-name": "Path 164626",
    d: "M224.964,294.2h-.028a.818.818,0,0,0-.006.259v.5c0,.3,0,.6,0,.895a5.648,5.648,0,0,0,.189,1.494,4.713,4.713,0,0,0,.256.739c.072.157.171.305.254.456s.151.334.231.5c.071.15.17.282.252.426s.143.274.226.4c.038.06.087.112.125.172.022.034.049.141.079.153l.008-.081",
    transform: "translate(-844.987 -297.047)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164627",
    "data-name": "Path 164627",
    d: "M231.63,326.21c0,.086,0,.172,0,.259a.526.526,0,0,0,.106.312c.09.142.182.283.274.424a4.625,4.625,0,0,1,.273.59,3.341,3.341,0,0,0,.28.447c.1.147.186.3.277.451a3.288,3.288,0,0,0,.477.77,1.862,1.862,0,0,0,.227.168,1.852,1.852,0,0,1,.29.262,4.427,4.427,0,0,0,.392.348c.229.194.459.376.7.554a4.8,4.8,0,0,0,.951.411c.222.1.454.174.673.279a1,1,0,0,0,.285.136",
    transform: "translate(-851.101 -326.232)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164628",
    "data-name": "Path 164628",
    d: "M243.748,246.452a2.611,2.611,0,0,1,.068-.768,3.078,3.078,0,0,1,.281-.678c.058-.1.087-.2.138-.31a2.429,2.429,0,0,1,.342-.477,3.1,3.1,0,0,1,.587-.642c-.022-.016-.046-.011-.072.015",
    transform: "translate(-862.151 -250.884)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164629",
    "data-name": "Path 164629",
    d: "M230.407,234.589a1.267,1.267,0,0,1,0-.245c.034-.149.2-.278.277-.407.119-.191.229-.386.343-.58.1-.162.167-.341.258-.507.049-.088.068-.18.119-.267a3.658,3.658,0,0,0,.226-.4,2.333,2.333,0,0,1,.584-.74,2.462,2.462,0,0,1,.79-.52,2.224,2.224,0,0,0,.263-.122,2.788,2.788,0,0,1,.358-.118,2.743,2.743,0,0,1,.371-.13,4.044,4.044,0,0,0,.6-.183,3.069,3.069,0,0,1,.867-.154c.339-.024.671-.034,1.011-.034a5.111,5.111,0,0,1,1.311.138,2.1,2.1,0,0,0,.24.064c.057.008.12,0,.178.012a2.257,2.257,0,0,1,.429.165,2.822,2.822,0,0,1,.327.182,3.735,3.735,0,0,1,.441.277c.206.156.414.306.62.462s.417.308.621.465a2.332,2.332,0,0,1,.306.267,2.037,2.037,0,0,1,.279.344c.132.242.208.51.326.758a2.431,2.431,0,0,0,.536.7,1.431,1.431,0,0,1,.344.933c0,.226,0,.452,0,.678",
    transform: "translate(-849.982 -238.677)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164630",
    "data-name": "Path 164630",
    d: "M350.72,246.18a.728.728,0,0,1,.207.078.8.8,0,0,1,.138.069c.087.057.172.116.258.17a.813.813,0,0,1,.251.328.968.968,0,0,0,.076.176c.04.056.086.089.122.145.1.16.188.329.286.491a1.517,1.517,0,0,0,.145.233c.032.036.074.064.1.1a1.912,1.912,0,0,1,.238.412c.05.106.1.206.142.317a.931.931,0,0,1,.062.273,1.311,1.311,0,0,0,.132.333,3.129,3.129,0,0,1,.192.773c.03.267.087.53.12.8a5.416,5.416,0,0,1,.008.645,2.074,2.074,0,0,1-.025.553c-.042.147-.06.306-.113.447a2.213,2.213,0,0,0-.094.411c-.02.119-.044.237-.068.355-.02.1-.063.189-.092.288a5.515,5.515,0,0,1-.192.571c-.065.157-.117.32-.183.477-.09.218-.136.461-.221.68a8.317,8.317,0,0,1-.347.831c-.033.063-.065.124-.1.184-.02.034-.033.09-.073.1a.091.091,0,0,1-.094-.044q-.205-.213-.426-.41",
    transform: "translate(-959.683 -253.265)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164631",
    "data-name": "Path 164631",
    d: "M417.786,256.788v-.029c0,.211.012.416-.006.627a6.736,6.736,0,0,1-.191.984q-.1.432-.186.868c-.041.173-.081.347-.123.52a2.089,2.089,0,0,0-.011.408c0,.347,0,.694,0,1.041s.012.661.042.991a3.056,3.056,0,0,0,.168.859,4.074,4.074,0,0,0,.927,1.433c.054-.012.174-.057.138-.124a7.315,7.315,0,0,1-.352-.657,10.233,10.233,0,0,1-.366-1.036c-.057-.191-.1-.387-.15-.579a5.009,5.009,0,0,1-.143-.514c-.051-.29-.086-.589-.109-.883a13.447,13.447,0,0,1,.1-2.284c.019-.22.063-.433.064-.655,0-.175,0-.35,0-.524s0-.376-.014-.565a.3.3,0,0,1,.027-.159,1.854,1.854,0,0,1,.23-.326c.132-.169.271-.333.411-.5.034-.038.14-.12.1-.18",
    transform: "translate(-1020.353 -261.772)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164632",
    "data-name": "Path 164632",
    d: "M415.236,286.636c-.1.012-.218-.068-.3-.1a4.581,4.581,0,0,1-.589-.217c-.2-.114-.42-.174-.623-.283a3.878,3.878,0,0,1-1.243-1.325,11.685,11.685,0,0,1-.9-1.394,4.381,4.381,0,0,1-.391-1.327c-.032-.221-.059-.442-.087-.663a8.066,8.066,0,0,1-.033-1.062v-1.276a11.9,11.9,0,0,0,.308,1.333c.039.239.092.477.14.714a5.359,5.359,0,0,0,.192.9,5.686,5.686,0,0,0,.568,1.027,14.081,14.081,0,0,1,.755,1.526,1.049,1.049,0,0,0,.209.327c.058.055.118.111.178.162s.111.071.163.112a2.067,2.067,0,0,1,.208.2c.147.158.282.32.421.484a2.789,2.789,0,0,0,.341.338,2.136,2.136,0,0,1,.253.282.732.732,0,0,0,.5.241,4.533,4.533,0,0,1,.647.141,4.5,4.5,0,0,0,.788.1c.108,0,.208.035.317.036h.274a3.469,3.469,0,0,0,.765-.032,10.374,10.374,0,0,0,1.106-.326,6.027,6.027,0,0,0,.652-.232,4.446,4.446,0,0,0,.5-.307c.218-.147.431-.305.642-.462a2.26,2.26,0,0,0,.354-.285c.086-.093.161-.189.237-.289a4.587,4.587,0,0,0,.745-1.127,6.143,6.143,0,0,1,.423-.932,3.867,3.867,0,0,0,.342-.62,3.775,3.775,0,0,0,.2-.686,6.851,6.851,0,0,0,.078-.97,11.758,11.758,0,0,0-.026-1.557c-.04-.337-.081-.672-.114-1.01-.011-.116-.023-.23-.032-.346-.017-.2-.036-.243-.244-.293",
    transform: "translate(-1014.703 -281.766)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164633",
    "data-name": "Path 164633",
    d: "M537.96,258.28a.7.7,0,0,0,.11.208c.1.18.169.371.268.551s.18.394.276.587c.081.163.185.314.26.48a3.1,3.1,0,0,1,.3.864c.076.553.1,1.11.126,1.667.01.2,0,.407,0,.61a1.858,1.858,0,0,1-.016.408c-.073.326-.145.649-.226.973a4.3,4.3,0,0,1-.145.549c-.066.168-.111.337-.164.509a4.957,4.957,0,0,1-.174.552c-.045.1-.061.219-.109.318a.183.183,0,0,1-.062-.146",
    transform: "translate(-1130.398 -264.297)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164634",
    "data-name": "Path 164634",
    d: "M529.751,264.92c0,.064,0,.13,0,.194a1.229,1.229,0,0,0,.1.51,9.692,9.692,0,0,1,.35.994c.093.342.176.681.258,1.024a8.849,8.849,0,0,1,.224,2.063c0,.255,0,.51,0,.765a2.765,2.765,0,0,1-.158.843,3.953,3.953,0,0,1-.911,1.461c-.138.148-.274.3-.409.448a1.906,1.906,0,0,0-.237.283,1.529,1.529,0,0,1-.295.332c-.145.135-.3.059-.473.006",
    transform: "translate(-1121.499 -270.351)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164635",
    "data-name": "Path 164635",
    d: "M467.353,335.19a.729.729,0,0,1-.1.352,4.443,4.443,0,0,1-.306.582,3.663,3.663,0,0,1-.894,1.093c-.246.186-.432.417-.66.621-.141.127-.259.272-.409.389a8.1,8.1,0,0,1-.853.573,4.987,4.987,0,0,1-1.357.63,3.569,3.569,0,0,1-.818.031h-.823c-.16,0-.32,0-.48,0s-.305-.038-.462-.035a2.534,2.534,0,0,1-.528-.06,4.589,4.589,0,0,1-.541-.216",
    transform: "translate(-1058.516 -334.419)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164636",
    "data-name": "Path 164636",
    d: "M414.533,251.361v-.9a3.373,3.373,0,0,1,0-.342,5.253,5.253,0,0,1,.484-1.455c.081-.19.151-.383.233-.572.03-.07.054-.142.083-.212a1.116,1.116,0,0,1,.2-.276c.057-.069.091-.148.145-.218.069-.09.153-.171.23-.254a2.625,2.625,0,0,1,.391-.329,1.244,1.244,0,0,1,.3-.2.245.245,0,0,1-.065.117c-.145.189-.327.349-.483.529a1.847,1.847,0,0,0-.178.287c-.093.159-.142.341-.233.5a2.623,2.623,0,0,0-.109.276c-.04.092-.094.186-.139.277-.078.153-.163.3-.241.455-.068.135-.132.275-.207.406a2.158,2.158,0,0,0-.244.417,1.651,1.651,0,0,0-.031.486",
    transform: "translate(-1017.858 -253.657)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164637",
    "data-name": "Path 164637",
    d: "M441.92,236.08a.358.358,0,0,0,.175-.071c.174-.1.346-.2.516-.308a7.593,7.593,0,0,1,.7-.43,2.6,2.6,0,0,1,.395-.119c.207-.061.411-.122.622-.174s.432-.114.651-.154a4.524,4.524,0,0,1,.695-.021,2.519,2.519,0,0,1,.684.141c.084.023.162.059.245.082a1.788,1.788,0,0,1,.206.052c.127.052.227.144.358.192a4.308,4.308,0,0,1,.508.222c.2.1.389.215.589.312.153.074.275.191.424.273a1.913,1.913,0,0,1,.492.313c.09.094.167.2.249.3.139.169.306.319.44.492.043.056.123.127.108.2",
    transform: "translate(-1042.834 -242.889)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164638",
    "data-name": "Path 164638",
    d: "M442.061,229.6a.9.9,0,0,1,.555.206,1.1,1.1,0,0,1,.357.38c.068.123.159.221.223.346a3.3,3.3,0,0,0,.243.335c.077.113.136.239.222.352a.894.894,0,0,1,.2.409c.041.211.1.417.13.629.008.047.03.088.036.133s-.012.067.006.1c.029-.009-.387-.1-.386-.138a.689.689,0,0,0-.138-.343.981.981,0,0,0-.138-.227c-.056-.062-.113-.123-.165-.188-.19-.242-.295-.552-.507-.775-.231-.243-.437-.5-.675-.741-.208-.208-.32-.486-.52-.7a2.127,2.127,0,0,0-.785-.451,5.753,5.753,0,0,0-.722-.226,4.419,4.419,0,0,0-1-.174,7.075,7.075,0,0,0-1.283.043,3.62,3.62,0,0,0-.828.312c-.269.121-.515.227-.779.329a1.067,1.067,0,0,0-.343.171c-.049.041-.1.07-.153.109a1.331,1.331,0,0,0-.163.176,2.334,2.334,0,0,0-.165.172,9.667,9.667,0,0,0-.663.853,1.092,1.092,0,0,0-.173.414c-.007.08,0,.166,0,.247",
    transform: "translate(-1036.015 -237.166)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164639",
    "data-name": "Path 164639",
    d: "M466.52,232.611c.146,0,.294.01.44,0,.1-.005.186-.034.283-.038a2.781,2.781,0,0,0,.31-.006,6.745,6.745,0,0,1,.681-.025c.191-.007.372-.037.565-.036a1.855,1.855,0,0,1,.459.033c.077.018.148.048.223.071.11.035.227.037.338.067a4.6,4.6,0,0,1,.605.173c.131.055.237.146.364.206.09.042.188.064.277.108a2.026,2.026,0,0,1,.337.228c.222.168.443.334.659.51.189.153.4.281.585.44.108.1.191.2.289.308s.164.23.267.334a1.619,1.619,0,0,1,.249.48,2.336,2.336,0,0,0,.294.62c.07.077.193.148.236.245a1.825,1.825,0,0,1-.4-.069",
    transform: "translate(-1065.263 -240.799)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164640",
    "data-name": "Path 164640",
    d: "M554.126,280.53c0,.381,0,.762,0,1.143,0,.288.086.563.116.848s.039.59.056.884c.03.525,0,1.058.006,1.585a2.014,2.014,0,0,1-.193.778.737.737,0,0,1-.164.3.264.264,0,0,1-.025-.168",
    transform: "translate(-1144.944 -284.583)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164641",
    "data-name": "Path 164641",
    d: "M502.032,286c0,.595-.026,1.2,0,1.791.03.633.065,1.267.066,1.9a5.966,5.966,0,0,1-.1,1.209,4.858,4.858,0,0,1-.173.682c-.056.153-.13.3-.19.448s-.139.321-.215.481a2.31,2.31,0,0,1-.236.469,3.406,3.406,0,0,1-.639.6,9.153,9.153,0,0,1-.862.614,3.862,3.862,0,0,1-.713.348,2.816,2.816,0,0,1-.3.108l-.051.006q-.428-.09-.857-.177",
    transform: "translate(-1093.746 -289.571)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164642",
    "data-name": "Path 164642",
    d: "M431.488,236.3v.018a2.038,2.038,0,0,0-.155-.673c-.059-.2-.139-.388-.2-.588a1.387,1.387,0,0,0-.163-.367c-.121-.184-.286-.335-.407-.519a6.291,6.291,0,0,0-1.153-1c-.079-.072-.147-.157-.23-.225-.1-.083-.215-.143-.312-.23a3.541,3.541,0,0,0-.819-.494,5.925,5.925,0,0,0-1.329-.413,3.14,3.14,0,0,0-.785-.094c-.2,0-.408,0-.612,0a4.44,4.44,0,0,0-1.5.171c-.276.1-.524.219-.791.337a2.411,2.411,0,0,0-.239.139c-.078.045-.164.072-.243.117-.108.062-.2.148-.311.2a.713.713,0,0,0-.2.1c0-.008-.172-.326-.172-.334.012.081-.053.139-.1.2a4.432,4.432,0,0,1-.286.37c-.131.135-.281.247-.406.388-.051.057-.125.109-.169.169-.029.042-.046.1-.074.147a2.255,2.255,0,0,0-.139.229c-.088.189-.169.381-.257.57s-.145.36-.236.532c-.056.106-.116.2-.163.313a4.937,4.937,0,0,0-.2.621,2.064,2.064,0,0,0-.113.616c0,.131,0,.26,0,.391s.034.311-.07.4",
    transform: "translate(-1022.548 -240.08)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164643",
    "data-name": "Path 164643",
    d: "M410.707,268.43a2.04,2.04,0,0,1-.029.519c-.044.17-.126.319-.173.484-.03.106-.034.214-.06.32-.034.138-.068.275-.1.413-.024.1-.063.194-.086.293-.031.135-.038.274-.058.41a2.4,2.4,0,0,0,.014,1.1c.11.306.225.623.3.938a2.632,2.632,0,0,0,.158.482.7.7,0,0,1,.1.258.61.61,0,0,1,0-.157",
    transform: "translate(-1013.86 -273.551)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164644",
    "data-name": "Path 164644",
    d: "M407.134,294.2h-.028a.818.818,0,0,0-.006.259v.5c0,.3,0,.6,0,.895a5.657,5.657,0,0,0,.189,1.494,4.713,4.713,0,0,0,.256.739c.072.157.171.305.254.456s.151.334.231.5c.07.15.17.282.251.426s.143.274.226.4c.038.06.087.112.125.172.022.034.049.141.079.153l.008-.081",
    transform: "translate(-1011.079 -297.047)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164645",
    "data-name": "Path 164645",
    d: "M413.8,326.21c0,.086,0,.172,0,.259a.526.526,0,0,0,.106.312c.09.142.182.283.274.424a4.644,4.644,0,0,1,.273.59,3.35,3.35,0,0,0,.28.447c.1.15.186.3.277.451a3.283,3.283,0,0,0,.477.77,1.863,1.863,0,0,0,.227.168,1.855,1.855,0,0,1,.289.262,4.445,4.445,0,0,0,.392.348c.229.194.459.376.7.554a4.8,4.8,0,0,0,.951.411c.222.1.454.174.673.279a1,1,0,0,0,.285.136",
    transform: "translate(-1017.194 -326.232)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164646",
    "data-name": "Path 164646",
    d: "M425.918,246.452a2.61,2.61,0,0,1,.068-.768,3.075,3.075,0,0,1,.281-.678c.058-.1.087-.2.138-.31a2.424,2.424,0,0,1,.342-.477,3.1,3.1,0,0,1,.587-.642c-.022-.016-.046-.011-.071.015",
    transform: "translate(-1028.244 -250.884)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164647",
    "data-name": "Path 164647",
    d: "M412.567,234.589a1.267,1.267,0,0,1,0-.245c.034-.149.2-.278.277-.407.119-.191.229-.386.343-.58.1-.162.167-.341.258-.507.049-.088.068-.18.119-.267a3.676,3.676,0,0,0,.226-.4,2.332,2.332,0,0,1,.584-.74,2.463,2.463,0,0,1,.79-.52,2.217,2.217,0,0,0,.263-.122,2.8,2.8,0,0,1,.358-.118,2.744,2.744,0,0,1,.371-.13,4.047,4.047,0,0,0,.6-.183,3.069,3.069,0,0,1,.867-.154c.339-.024.671-.034,1.011-.034a5.112,5.112,0,0,1,1.311.138,2.085,2.085,0,0,0,.24.064c.057.008.12,0,.178.012a2.252,2.252,0,0,1,.429.165,2.8,2.8,0,0,1,.326.182,3.723,3.723,0,0,1,.441.277c.206.156.414.306.62.462s.417.308.621.465a2.32,2.32,0,0,1,.306.267,2.037,2.037,0,0,1,.279.344c.132.242.208.51.326.758a2.432,2.432,0,0,0,.536.7,1.4,1.4,0,0,1,.344.933c0,.226,0,.452,0,.678",
    transform: "translate(-1016.065 -238.677)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164648",
    "data-name": "Path 164648",
    d: "M532.89,246.18a.727.727,0,0,1,.207.078.815.815,0,0,1,.138.069c.087.057.172.116.258.17a.815.815,0,0,1,.251.328.957.957,0,0,0,.076.176c.04.056.086.089.122.145.1.16.188.329.286.491a1.513,1.513,0,0,0,.145.233c.032.036.074.064.1.1a1.91,1.91,0,0,1,.238.412c.05.106.1.206.142.317a.933.933,0,0,1,.062.273,1.3,1.3,0,0,0,.133.333,3.12,3.12,0,0,1,.192.773c.03.267.087.53.12.8a5.442,5.442,0,0,1,.008.645,2.07,2.07,0,0,1-.025.553c-.042.147-.06.306-.113.447a2.218,2.218,0,0,0-.094.411c-.02.119-.044.237-.068.355-.02.1-.063.189-.092.288a5.48,5.48,0,0,1-.192.571c-.065.157-.117.32-.183.477-.09.218-.136.461-.221.68a8.418,8.418,0,0,1-.347.831c-.033.063-.065.124-.1.184-.02.034-.033.09-.073.1a.09.09,0,0,1-.094-.044q-.205-.213-.426-.41",
    transform: "translate(-1125.775 -253.265)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164649",
    "data-name": "Path 164649",
    d: "M602.294,260.684v-2.473a13.5,13.5,0,0,0-.019-1.646c-.034-.275-.1-.554-.106-.832-.008-.293,0-.588,0-.882a12.442,12.442,0,0,1,.242-1.681,10.014,10.014,0,0,0,.049-1.291v-1.99a1.45,1.45,0,0,0-.02-.35c-.038-.157-.1-.17-.269-.188",
    transform: "translate(-1188.938 -256.155)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164650",
    "data-name": "Path 164650",
    d: "M599.814,242.81v1.778c0,.436.012.874,0,1.31-.008.325-.049.65-.074.974-.053.679-.1,1.37-.093,2.05,0,.349-.037.693-.043,1.041s0,.665-.029,1c-.035.466-.038.933-.084,1.4a3.615,3.615,0,0,0-.018.89.288.288,0,0,0,.04.115c.04.06.109.094.145.157a.751.751,0,0,1,.037.329c.012.153.052.3.076.455a4.777,4.777,0,0,1,.085.536c.007.181,0,.36,0,.54,0-.3-.414-.678-.414-.975a2.131,2.131,0,0,0-.007-.59l-.035-.007",
    transform: "translate(-1186.415 -250.192)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164651",
    "data-name": "Path 164651",
    d: "M595,252.078c0-.491.012-.982,0-1.473-.005-.3-.109-.6-.123-.9-.016-.326,0-.653,0-.979a4.667,4.667,0,0,1,.107-1.067,8.793,8.793,0,0,0,.226-1.143c.034-.368.04-.729.04-1.1a5.96,5.96,0,0,1,.009-.733,9.262,9.262,0,0,0,.031-1.224c0-.287.051-.568.075-.854s.007-.549.009-.822a9.118,9.118,0,0,0-.209-1.657,3.777,3.777,0,0,0-.1-.4.737.737,0,0,1-.053-.267.457.457,0,0,0-.3-.038",
    transform: "translate(-1182.139 -247.095)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164652",
    "data-name": "Path 164652",
    d: "M596.368,231.42v-2.251a4.337,4.337,0,0,0,0-.523,1,1,0,0,1-.022-.455.232.232,0,0,0-.222-.038,3.42,3.42,0,0,0,.358.417c.169.21.318.439.47.66.139.2.274.408.411.611.126.186.275.342.413.52.3.38.57.778.866,1.16.272.349.513.722.8,1.058.1.117.179.25.277.366a1.32,1.32,0,0,0,.293.223,2.531,2.531,0,0,1,.542.488c.271.341.6.617.879.947a4.51,4.51,0,0,0,.523.563,1.416,1.416,0,0,1,.195.184.116.116,0,0,0,.093.082",
    transform: "translate(-1183.425 -236.817)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164653",
    "data-name": "Path 164653",
    d: "M608.77,253.59c.054.007.159.206.193.252.284.379.589.742.9,1.1.364.426.75.817,1.151,1.207.317.308.6.639.9.959.161.17.336.326.5.493a4.42,4.42,0,0,0,.378.407c.245.2.529.349.778.539a4.211,4.211,0,0,0,.457.314,1.7,1.7,0,0,1,.221.122,1.633,1.633,0,0,1,.167.183c.076.079.157.147.228.233.1.121.186.252.289.371a3.1,3.1,0,0,0,.417.436",
    transform: "translate(-1194.958 -260.021)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164654",
    "data-name": "Path 164654",
    d: "M635.49,276.08a.291.291,0,0,0,.124.2c.107.123.217.241.332.357.275.283.552.562.816.854.37.409.747.8,1.093,1.234.229.282.458.563.693.84.29.341.6.651.907.976.461.488.884,1.015,1.31,1.533a3.567,3.567,0,0,0,.538.539,1.23,1.23,0,0,1,.351.383,4.728,4.728,0,0,0,.371.6,1.006,1.006,0,0,0,.328.257c.072.039.406.156.368.286-.027.007-.038-.006-.035-.038",
    transform: "translate(-1219.32 -280.526)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164655",
    "data-name": "Path 164655",
    d: "M654.031,293.559c.106.025.218.236.289.319.215.254.441.5.669.745.459.484.934.954,1.407,1.424.282.28.531.589.818.863.151.144.314.267.458.42s.272.337.427.485a9.3,9.3,0,0,1,.691.74,9.058,9.058,0,0,1,.612.717,4.109,4.109,0,0,1,.233.411.613.613,0,0,0,.31.206c-.11,0-.121-.006-.182-.1-.036-.058-.067-.115-.107-.169a5.209,5.209,0,0,1-.415-.641c-.047-.089-.113-.166-.164-.253a1.526,1.526,0,0,0-.289-.319c-.081-.079-.145-.174-.229-.251s-.155-.112-.222-.179a1,1,0,0,1-.169-.286,3.516,3.516,0,0,1-.207-.485,3.772,3.772,0,0,0-.54-.976,2.311,2.311,0,0,0-.581-.558,3.4,3.4,0,0,1-.519-.515,4.506,4.506,0,0,1-.621-.814c-.166-.283-.275-.6-.419-.9a2.331,2.331,0,0,0-.643-.726q-.3-.251-.614-.487a1.057,1.057,0,0,0-.286-.2",
    transform: "translate(-1235.96 -295.068)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164656",
    "data-name": "Path 164656",
    d: "M642.05,295.29c.209.206.4.433.607.636.313.3.667.539,1,.814.391.32.763.67,1.121,1.027s.675.72,1.061,1.046a5.337,5.337,0,0,0,.878.705c.446.237.908.449,1.333.724a5.807,5.807,0,0,1,.864.713.522.522,0,0,1,.207.382c.006.224.044.439.041.667a.948.948,0,0,0,.009.16,1.437,1.437,0,0,0,.042.25.271.271,0,0,0,.032-.217",
    transform: "translate(-1225.301 -298.041)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164657",
    "data-name": "Path 164657",
    d: "M624.661,230.927c-.041.2.2.4.31.536a6.114,6.114,0,0,0,.509.548c.115.113.238.219.359.327.059.052.128.09.188.14a1.53,1.53,0,0,1,.2.256c.169.222.327.455.5.672.09.113.2.206.292.318a3.192,3.192,0,0,0,.245.291c.152.148.356.2.509.347a3.941,3.941,0,0,1,.272.286c.04.046-.266.123-.2.135.038.329.377.234.55.384a3.342,3.342,0,0,1,.267.3,3.221,3.221,0,0,0,.259.3,1.315,1.315,0,0,1,.25.236c.055.088.086.183.131.269.054.1.149.119.229.187.131.11.2.318.32.446a4.333,4.333,0,0,1,.433.582,6.01,6.01,0,0,0,.382.6c.058.069.134.115.2.177s.124.134.2.2a2.545,2.545,0,0,1,.4.332c.075.094.139.189.218.278.053.059.11.112.164.169.156.165.305.334.457.5.183.2.439.928.753.953a20.483,20.483,0,0,0-.058-2.614,7.7,7.7,0,0,1-.024-1,.8.8,0,0,0-.083-.378,1.948,1.948,0,0,1-.12-.551c-.023-.256-.038-.511-.065-.768a18.2,18.2,0,0,1-.1-1.935v-1.282a2.229,2.229,0,0,1,.067-.75,4.1,4.1,0,0,0,.121-.509,2.948,2.948,0,0,0,.019-.328c.007-.086.041-.167.046-.253a.188.188,0,0,0-.017-.117c-.028-.039-.069.008-.069-.057,0-.542-.206-.913-.206-1.454v1.016c0,.345-.005.693,0,1.039a2.168,2.168,0,0,0,.032.557,2.088,2.088,0,0,0,.079.376c.042.289.062.59.091.882s.063.576.092.866a12.59,12.59,0,0,0,.131,1.291,7.65,7.65,0,0,1,.2,1.391c.014.684,0,1.372,0,2.056a8.647,8.647,0,0,0,.124,1.649c.035.182.03.363.071.542.029.124.061.253.085.377a4.791,4.791,0,0,1,.05.9c0,.151,0,.3-.006.454a.365.365,0,0,1-.021.17c-.089-.091-.088-.339-.1-.459a1.432,1.432,0,0,1,.027-.39,6.539,6.539,0,0,0,.053-1.275q0-.642,0-1.283c0-1.5,0-3.009-.09-4.51-.067-1.156-.276-2.3-.285-3.464-.005-.642,0-1.284,0-1.926,0,.926.246,1.895.248,2.821,0,.225.005.451-.008.675a1.052,1.052,0,0,0-.015.278.673.673,0,0,0,.094.183c.063-.11.011-.287.011-.409,0-.29,0-.582,0-.872a9.889,9.889,0,0,0-.02-1.087,11.265,11.265,0,0,1-.02-1.243c0-.186,0-.372,0-.56a.793.793,0,0,0-.007-.211l-.034,0",
    transform: "translate(-1209.443 -237.173)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164658",
    "data-name": "Path 164658",
    d: "M606.358,248.9a.525.525,0,0,0,.079.328,4.287,4.287,0,0,0,.5.739,7.335,7.335,0,0,1,.475.588c.1.152.2.3.306.45a7.406,7.406,0,0,0,.459.623c.156.174.3.352.439.539a2,2,0,0,0,.6.508,4.271,4.271,0,0,1,.617.4,2.807,2.807,0,0,1,.427.453c.065.092.1.194.155.288.028.044.083.07.081.128",
    transform: "translate(-1192.753 -255.745)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164659",
    "data-name": "Path 164659",
    d: "M604.075,290.522a8.273,8.273,0,0,0-.064-1.363c-.089-.54-.241-1.067-.3-1.613a5.457,5.457,0,0,1-.006-.631c0-.277-.037-.546-.045-.822-.01-.357,0-.716,0-1.072v-.85c0-.2.044-.392.043-.594,0-.342,0-.684,0-1.026,0-.187.038-.364.045-.549.005-.136-.04-.3.043-.422a.136.136,0,0,0-.169-.033",
    transform: "translate(-1190.263 -285.498)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164660",
    "data-name": "Path 164660",
    d: "M594.216,270.46v2.032c0,.728.005,1.462-.062,2.188-.023.246-.044.494-.057.74s-.06.472-.088.711-.078.479-.1.721a4.751,4.751,0,0,1-.069.512.139.139,0,0,1-.076,0",
    transform: "translate(-1181.273 -275.402)",
    fill: "none",
    stroke: "#e32028",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoonEnglish);
export default __webpack_public_path__ + "static/media/soonEnglish.a77c557837db801e48b61d2db4f5322e.svg";
export { ForwardRef as ReactComponent };